/**
 * Formatta una data ISO in formato DD/MM
 * @param isoDate - Data in formato ISO (es. "2026-02-08T11:00:00.000Z")
 * @returns Data formattata come DD/MM (es. "08/02")
 */
export const formatDateToDDMM = (isoDate: string): string => {
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${day}/${month}`;
};

/**
 * Formatta una data ISO in formato DD/MM/YYYY
 * @param isoDate - Data in formato ISO (es. "2026-02-08T11:00:00.000Z")
 * @returns Data formattata come DD/MM/YYYY (es. "08/02/2026")
 */
export const formatDateToDDMMYYYY = (isoDate: string): string => {
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

/**
 * Formatta una data ISO in formato ora:minuti (es. "11:00")
 * @param isoDate - Data in formato ISO (es. "2026-02-08T11:00:00.000Z")
 * @returns Ora formattata come HH:MM (es. "11:00")
 */
export const formatTimeToHHMM = (isoDate: string): string => {
  const date = new Date(isoDate);
  // Sottraiamo 15 minuti
  date.setMinutes(date.getMinutes() - 15);
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
};

/**
 * Controlla se una data è dopo adesso
 * @param isoDate - Data in formato ISO (es. "2026-02-08T11:00:00.000Z")
 * @returns true se la data è nel futuro, false altrimenti
 */
export const isAfterNow = (isoDate: string): boolean => {
  const date = new Date(isoDate);
  const now = new Date();
  return date > now;
};

/**
 * Controlla se una data è prima di adesso
 * @param isoDate - Data in formato ISO (es. "2026-02-08T11:00:00.000Z")
 * @returns true se la data è nel passato, false altrimenti
 */
export const isBeforeNow = (isoDate: string): boolean => {
  const date = new Date(isoDate);
  const now = new Date();
  return date < now;
};

/**
 * Controlla se l'orario corrente è tra due date
 * @param startDate - Data di inizio in formato ISO
 * @param endDate - Data di fine in formato ISO
 * @returns true se l'orario corrente è tra le due date, false altrimenti
 */
export const isNowBetween = (startDate: string, endDate: string): boolean => {
  const now = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);
  return now >= start && now <= end;
};

/**
 * Controlla se una data è oggi
 * @param isoDate - Data in formato ISO (es. "2026-02-08T11:00:00.000Z")
 * @returns true se la data è oggi, false altrimenti
 */
export const isToday = (isoDate: string): boolean => {
  const date = new Date(isoDate);
  const now = new Date();
  return (
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear()
  );
};
